module.exports = __webpack_public_path__ + "static/media/undraw_reminders_re_gtyb.e18612f2.svg";